import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { bindParent } from "@/api/invite";
import { toastSuccess, toastError } from "@/utils/toast";
import { unlockSharedAudio } from "@/utils/audioPlayer";

/**
 * 落地页 — 邀请二维码扫码入口
 *
 * 布局：
 * 1. 顶部横幅图片（熊猫旅行主题，完整显示）
 * 2. 图片底部SVG波浪过渡
 * 3. 统计文字说明区
 * 4. [立即加入 >>] 按钮，点击绑定推荐人
 */
export default function LandingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "熊猫旅行 - 像朋友一样旅行";
  }, []);

  const handleJoin = async () => {
    const code = searchParams.get("code");
    if (!code) {
      toastError("无效的邀请链接");
      return;
    }

    // ★ 利用用户点击手势提前解锁音频子系统
    unlockSharedAudio();

    setLoading(true);
    try {
      await bindParent(code);
      toastSuccess("绑定成功，欢迎加入！");
      setTimeout(() => navigate("/ai-voice"), 1500);
    } catch (err: any) {
      toastError(err.message || "绑定失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* 顶部横幅区域 */}
      <div className="w-full">
        <img
          src="/landing-banner.png"
          alt="像朋友一样旅行"
          className="w-full h-auto block"
        />
        {/* SVG波浪过渡 */}
        <svg
          viewBox="0 0 375 40"
          preserveAspectRatio="none"
          className="w-full h-[40px] block"
          style={{ marginTop: "-1px" }}
        >
          <path
            d="M0,0 L375,0 L375,20 Q312,40 250,20 Q187,0 125,20 Q62,40 0,20 Z"
            fill="#ffffff"
          />
        </svg>
      </div>

      {/* 内容区域 */}
      <div className="flex-1 flex flex-col items-center px-8 pt-6 pb-10">
        {/* 统计文字说明 */}
        <p className="text-gray-700 text-[15px] leading-relaxed text-center">
          已有<span className="text-orange-500 font-bold text-3xl mx-0.5">50,000</span>
          旅行者通过我们
        </p>
        <p className="text-gray-700 text-[15px] mt-6 text-center">认识了当地朋友。</p>

        {/* 立即加入按钮 */}
        <button
          onClick={handleJoin}
          disabled={loading}
          className="mt-10 w-full max-w-sm bg-[#F7934A] text-white text-base font-medium rounded-full py-3.5 active:opacity-80 transition-opacity cursor-pointer disabled:opacity-60"
          style={{ boxShadow: "0 4px 12px rgba(247,147,74,0.35)" }}
        >
          {loading ? "处理中..." : "立即加入 >>"}
        </button>
      </div>
    </div>
  );
}
